import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ProfilePicturePipe } from './profilePicture/profilePicture.pipe';

@NgModule({
  imports: [CommonModule],
  exports: [ProfilePicturePipe],
  declarations: [ProfilePicturePipe]
})
export class PipesModule {}
